const SESSION_SYNC_KEY = "bp_session_sync";

export {
  getHomePathForRole,
  getRedirectForRole,
  isAgentRoute,
  isClientRoute,
  isSharedRoute,
} from "./ProtectedRoute";

export function broadcastSessionChange(user) {
  localStorage.setItem(
    SESSION_SYNC_KEY,
    JSON.stringify({
      ts: Date.now(),
      userId: user?._id ?? null,
      userRole: user?.user_role ?? null,
      logout: false,
    })
  );
}

export function broadcastSessionLogout() {
  localStorage.setItem(
    SESSION_SYNC_KEY,
    JSON.stringify({
      ts: Date.now(),
      logout: true,
    })
  );
}

export function parseSessionSyncPayload(value) {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function isSameSession(user, userId, userRole) {
  if (!user) {
    return false;
  }

  return (
    String(user._id) === String(userId) &&
    Number(user.user_role) === Number(userRole)
  );
}

export { SESSION_SYNC_KEY };
